export default [
  {
    path: '/manifests-pickup',
    name: 'manifests-list',
    props: true,
    component: () => import('@/views/manifestsPickup/Index.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Suivi sous-traitance',
      breadcrumb: [
        {
          text: 'Suivi sous-traitance',
          to: { name: 'manifests-list' },
        },
        {
          text: 'Liste',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'outsourcing_company'],
    },
  },
  {
    path: '/manifests-pickup/create',
    name: 'manifest-create',
    props: true,
    component: () => import('@/views/manifestsPickup/Create.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Créer un bon de sous-traitance',
      breadcrumb: [
        {
          text: 'Suivi sous-traitance',
          to: { name: 'manifests-list' },
        },
        {
          text: 'Créer',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager'],
    },
  },
  {
    path: '/manifests-pickup/:id',
    name: 'manifest-detail',
    props: true,
    component: () => import('@/views/manifestsPickup/Show.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Détail bon de sous-traitance',
      breadcrumb: [
        {
          text: 'Suivi sous-traitance',
          to: { name: 'manifests-list' },
        },
        {
          text: 'Détail',
          active: true,
        },
      ],
      roles: ['admin', 'superadmin', 'manager', 'outsourcing_company'],
    },
  },
]
